import styled from 'styled-components';

const ExchangeUnitInput = styled.input`
  border: solid 1px #d4ddd4;
  width: 130px;
  height: 40px;
  font-family: HelveticaNeue;
  padding-right: 10px;
  color: ${props => props.theme.fontColors.thead};
  text-align:center;
  &&:focus {
    border: 1px solid #505050 !important;
    outline: none !important;
    /* outline-color: #505050 !important;
    outline-width: 1px !important; */
  }
`;

export default ExchangeUnitInput;
